import React from 'react'

const CustomerTermsAndConditions = () => {
    return (
        <div>CustomerTermsAndConditions</div>
    )
}

export default CustomerTermsAndConditions